import { useEffect, useState } from "react";
import { MEDIA } from "./breakpoints";

/**
 * Subscribe to a CSS media query and re-render when it starts or stops matching.
 * Pass a query string such as one of the values in MEDIA.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== "undefined" && "matchMedia" in window
      ? window.matchMedia(query).matches
      : false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }, [query]);

  return matches;
};

/** True on phone-width viewports (narrower than the `md` breakpoint). */
export const useIsMobile = (): boolean => !useMediaQuery(MEDIA.mdUp);
